const getDaysWord = (remainingDays: number): string => {
  if (remainingDays === 1) {
    return "день";
  }

  const lastDigit = remainingDays % 10;
  const lastTwoDigits = remainingDays % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return "дней";
  }

  if (lastDigit >= 2 && lastDigit <= 4) {
    return "дня";
  }

  return "дней";
};

const getVerbForm = (remainingDays: number): string => {
  if (remainingDays === 1) {
    return "остался";
  }

  return "осталось";
};

export const formatDaysLeft = (remainingDays: number): string => {
  if (remainingDays === 0) {
    return "менее 1 дня осталось";
  }

  const daysWord = getDaysWord(remainingDays);
  const verbForm = getVerbForm(remainingDays);

  return `${daysWord} ${verbForm}`;
};

export const getChecksWord = (count: number): string => {
  const lastDigit: number = count % 10;
  const lastTwoDigits: number = count % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return "проверок";
  }

  if (lastDigit === 1) {
    return "проверка";
  }

  if (lastDigit >= 2 && lastDigit <= 4) {
    return "проверки";
  }

  return "проверок";
};

const getChecksVerb = (count: number): string => {
  if (count === 1) {
    return "осталась";
  }
  return "осталось";
};

export const formatChecksLeft = (count: number): string => {
  if (count === 0) {
    return "менее 1 проверки осталось";
  }

  const checksWord: string = getChecksWord(count);
  const verbForm: string = getChecksVerb(count);

  return `${checksWord} физ.лиц ${verbForm}`;
};
